import { FormattedMessageProps } from '../../../components/FormattedMessage';

/**
 * Reexport of server side FormattedMessage to avoid loading it on client.
 */
const ServerFormattedMessage = async (props: FormattedMessageProps) => {
  const { default: FormattedMessage } = await import(
    '../../../components/FormattedMessage'
  );

  return <FormattedMessage {...props} />;
};

export default ServerFormattedMessage;
